import React, { useEffect, useState } from 'react';
import { getContent } from '@/lib/api';
import { Seo } from '@/components/Seo';
import { PageHero } from '@/components/PageHero';
import { RevealGroup, RevealItem } from '@/components/Reveal';
import { ClientsMarquee } from '@/components/ClientsMarquee';
import { CtaSection } from '@/components/CtaSection';

export default function Clients() {
  const [clients, setClients] = useState([]);
  useEffect(() => {
    getContent('clients').then(setClients).catch(() => {});
  }, []);

  return (
    <>
      <Seo title='Our Valuable Clients' description='Trusted across projects that matter — builders, developers and infrastructure clients across Tamil Nadu.' path='/clients' image='/media/img/liebherr-site.jpg' />
      <PageHero eyebrow='Our Valuable Clients' title='Trusted across projects that matter.' subtitle='A selection of the builders, developers and organisations we have worked with.' image='/media/img/liebherr-site.jpg' />

      <section className='bg-[#F6F5F1] py-20 lg:py-28'>
        <div className='container-x'>
          <RevealGroup className='grid gap-px overflow-hidden rounded-2xl border border-[#20272A]/10 bg-[#20272A]/10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
            {clients.map((c) => (
              <RevealItem key={c.name}>
                <div className='group flex h-40 flex-col items-center justify-center gap-2 bg-[#F6F5F1] p-6 text-center transition-colors duration-300 hover:bg-white' data-testid='client-card'>
                  {c.logo ? (
                    <img
                      src={c.logo}
                      alt={c.name}
                      loading='lazy'
                      className='max-h-16 w-auto max-w-[80%] object-contain opacity-85 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0'
                    />
                  ) : (
                    <>
                      <span className='font-head text-xl font-semibold tracking-tight text-[#20272A]/55 transition-colors duration-300 group-hover:text-[#075B61]'>{c.name}</span>
                      {c.tagline && <span className='text-[11px] uppercase tracking-wider text-[#20272A]/35'>{c.tagline}</span>}
                    </>
                  )}
                  <span className='block h-px w-0 bg-[#B88A3B] transition-all duration-500 group-hover:w-10' />
                </div>
              </RevealItem>
            ))}
          </RevealGroup>
          <p className='mt-8 text-center text-sm text-[#20272A]/45'>More client brand logos are being added.</p>
        </div>
      </section>

      <section className='relative bg-[#20272A] py-16'>
        <div className='grain absolute inset-0' />
        <div className='relative'>
          <ClientsMarquee dark />
        </div>
      </section>

      <CtaSection />
    </>
  );
}
